import { useEffect, useState } from 'react';
import config from '../../common/config';

import './styles/Digest4.less';

const Digest = ({ seq, play = false, onDataLoaded }: any) => {
  const [delayPlay, setDelayPlay] = useState(false);
  useEffect(() => {
    if (play) {
      setTimeout(() => {
        setDelayPlay(true);
      }, 300);
    } else {
      setDelayPlay(false);
    }
  }, [play]);

  return (
    <div className={`digest-wrapper digest-wrapper-${seq}`}>
      <div
        className={`digest ${delayPlay ? 'ani-play' : ''}`}
        onTransitionEnd={() => {
          // setPlayText(true);
        }}
      >
        <div className="logo-q">
          <img src={config.getFullUrl('images/logo-q.svg')} alt="logo quality" />
        </div>
      </div>

      <div className={`text-block`}>
        <div className={`titles ${delayPlay ? 'ani-fade-in' : ''}`}>
          <div className="title title-primary">执行品质</div>
          <div className="title title-secondary">高复用</div>
        </div>
        <div className={`description ${delayPlay ? 'ani-fade-in' : ''}`}>
          《Design Guideline》→《Merchandise Design Guide》→《Development Handbook》 …
        </div>
      </div>
    </div>
  );
};

export default Digest;
